export const preferences = {
  mode: "主题",
  text: "文本",
  translationFeature: "翻译功能",
};
